import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSsmUiFlags } from '@utilities/hooks/useSsmUiFlags/useSsmUiFlags';
import { ROUTE_CONSTANTS } from '@utilities/RouteConstants';


/***
 * REMOVE THIS COMPONENT WHEN TESTING IS NO LONGER NEEDED (REMOVE_TEST)
 * Also remove references in the following code:
 *   * Routes.tsx
 *   * LaunchDarklyAppWrapper.tsx
 *   * RouteConstants.ts
 *   * SsmUiFlagsTypes.ts
 * Search for REMOVE_TEST to find all references that should be removed
 ***/
export const TestErrorPage = () => {
	const { wTestThrowError } = useSsmUiFlags();

	if (wTestThrowError) {
		throw new Error('TestErrorPage: w-test-throw-error enabled');
	}

	return <Redirect to={ROUTE_CONSTANTS.HOME} />;
};
